module.exports = __webpack_public_path__ + "img/miseongnyeon.9fe180a7.jpg";